import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link ShowActionBarCommand}
 */
export type ShowActionBarCommandProperties = CommandProperties;

/**
 * Command to show the database action bar in the native embed experience.
 *
 * The action bar provides contextual actions for selected database entries or fields,
 * maintaining consistency with the standalone database experience while being
 * integrated into the host application (Whiteboards/Confluence).
 *
 * @see {@link DismissActionBarCommand}
 */
export const ShowActionBarCommand = createCommand<ShowActionBarCommandProperties, void>(
  'show-action-bar-command'
);
